import React from 'react';
import { ProgressProduct } from '../../../../../_mexablock/helpers/components/ProgressProduct';
import {
  formatPrice,
  formatPriceSinDecimal,
} from '../../../../../_mexablock/helpers';

type Props = {
  dataIndicators: any;
};

const IndicadoresProd: React.FC<Props> = ({ dataIndicators }) => {
  const disponible = dataIndicators?.totales?.find(
    (item: any) => item.status_id === 9
  );
  const asignadas = dataIndicators?.totales?.find(
    (item: any) => item.status_id === 10
  );
  const activadas = dataIndicators?.totales?.find(
    (item: any) => item.status_id === 7
  );
  const portada = dataIndicators?.totales?.find(
    (item: any) => item.status_id === 8
  );
  const salidas = dataIndicators?.totales?.find(
    (item: any) => item.status_id === 11
  );
  const totales = dataIndicators?.totales ?? [];

  const totalCount = totales.reduce(
    (acc: any, item: any) => acc + item.count,
    0
  );
  const stockDisponible = Number(disponible?.count ?? 0);

  const colorPorStatus: Record<number, string> = {
    9: '#11CC2A', // Disponible
    10: '#009EF7', // Asignada
    7: '#773ADA', // Activada
    8: '#FFBB00', // Portada
    11: '#D9D9D9', // Enviada
  };
  const segmentos = totales.map((item: any) => ({
    porcentaje:
      totalCount > 0 ? Math.round((item.count / totalCount) * 100) : 0,
    color: colorPorStatus[item.status_id] ?? '#ee2d41', // fallback color
  }));
  return (
    <>
      <div className="card">
        <div className="card-body p-0">
          <div className="row">
            <div className="col-3 border d-flex justify-content-center align-items-center">
              <div className="text-center">
                <div>
                  <span className="fw-bold fs-3">Valor Inventario</span>
                </div>
                <div>
                  <span className="fw-bolder fs-3">
                    {dataIndicators
                      ? formatPrice(dataIndicators.total, 'es-MX', 'MXN', 2, 2)
                      : '$ 0.00'}
                  </span>
                </div>
              </div>
            </div>

            <div className="col-9 mt-9">
              <div className="d-flex gap-0">
                <div className="d-flex align-items-center w-100 me-5">
                  <div
                    style={{
                      width: '12px',
                      height: '25px',
                      backgroundColor: '#11CC2A',
                      marginRight: '8px',
                    }}
                  ></div>
                  <span className="fw-bolder fs-1">
                    {' '}
                    {disponible ? formatPriceSinDecimal(disponible.count) : 0}
                  </span>
                  <span className="ms-5 fw-normal fs-3">Disponibles</span>
                </div>
                {/* <div className="d-flex align-items-center w-100">
                  <div
                    style={{
                      width: '12px',
                      height: '15px',
                      backgroundColor: '#009EF7',
                      marginRight: '5px',
                    }}
                  ></div>
                  <span>Enviadas</span>
                  <span className="ms-5 fw-bold">
                    {asignadas ? formatPriceSinDecimal(asignadas.count) : 0}
                  </span>
                </div> */}
                <div className="d-flex align-items-center w-100">
                  <div
                    style={{
                      width: '12px',
                      height: '15px',
                      backgroundColor: '#773ADA',
                      marginRight: '8px',
                    }}
                  ></div>
                  <span>Activadas</span>
                  <span className="ms-5 fw-bold">
                    {activadas ? formatPriceSinDecimal(activadas.count) : 0}
                  </span>
                </div>
                <div className="d-flex align-items-center w-100">
                  <div
                    style={{
                      width: '12px',
                      height: '15px',
                      backgroundColor: '#FFBB00',
                      marginRight: '8px',
                    }}
                  ></div>
                  <span>Portadas</span>
                  <span className="ms-5 fw-bold">
                    {portada ? formatPriceSinDecimal(portada.count) : 0}
                  </span>
                </div>
                <div className="d-flex align-items-center w-100">
                  <div
                    style={{
                      width: '12px',
                      height: '15px',
                      backgroundColor: '#D9D9D9',
                      marginRight: '8px',
                    }}
                  ></div>
                  <span>Asignadas</span>
                  <span className="ms-5 fw-bold">
                    {salidas ? formatPriceSinDecimal(salidas.count) : 0}
                  </span>
                </div>
              </div>
              <div className="d-flex mt-5 gap-0 pb-5 mt-9 pe-3">
                <ProgressProduct segments={segmentos} />
              </div>
              {stockDisponible === 0 ? (
                <span className="badge badge-light-danger mb-5 mt-3 fs-6">
                  Sin stock
                </span>
              ) : stockDisponible < 300 ? (
                <span className="badge badge-light-warning mb-5 mt-3 fs-6">
                  Stock bajo
                </span>
              ) : (
                <span className="badge badge-light-success mb-5 mt-3 fs-6">
                  En stock
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { IndicadoresProd };
